import { deployments } from "@mintkudos/protocol";
import { AppEnv } from "../config/env";

export const generateOpenSeaLink = (chainId: number, tokenId: number) => {
  if (AppEnv === "production") {
    return `https://opensea.io/assets/matic/${deployments[AppEnv]?.proxy}/${tokenId}`;
  } else {
    return `https://testnets.opensea.io/assets/mumbai/${deployments[AppEnv]?.proxy}/${tokenId}`;
  }
};

export const generateRaribleLink = (chainId: number, tokenId: number) => {
  const contractAddress = deployments[AppEnv]?.proxy.toLowerCase();
  if (AppEnv === "staging" || AppEnv === "sandbox") {
    return `https://testnet.rarible.com/token/polygon/${contractAddress}:${tokenId}`;
  }
  return `https://rarible.com/token/polygon/${contractAddress}:${tokenId}`;
};

export const openUrl = (url: string) => {
  if (window) {
    window.open(url);
  }
};
